import { render, staticRenderFns } from "./Discrepancy.vue?vue&type=template&id=c7db6318&scoped=true"
import script from "./Discrepancy.vue?vue&type=script&lang=js"
export * from "./Discrepancy.vue?vue&type=script&lang=js"
import style0 from "./Discrepancy.vue?vue&type=style&index=0&id=c7db6318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7db6318",
  null
  
)

export default component.exports